// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__eUqo6","body":"NotFound_body__20BcQ"};